import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ShieldIcon = ({
  className,
  ...props
}: {
  className?: string;
} & SvgIconProps) => (
  <SvgIcon
    className={className}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      d="M19.9988 12.9999C19.9988 17.9999 16.4988 20.4999 12.3388 21.9499C12.121 22.0237 11.8843 22.0201 11.6688 21.9399C7.49879 20.4999 3.99879 17.9999 3.99879 12.9999V5.99985C3.99879 5.73464 4.10415 5.48028 4.29169 5.29275C4.47922 5.10521 4.73358 4.99985 4.99879 4.99985C6.99879 4.99985 9.49879 3.79985 11.2388 2.27985C11.4506 2.09885 11.7201 1.9994 11.9988 1.9994C12.2774 1.9994 12.5469 2.09885 12.7588 2.27985C14.5088 3.80985 16.9988 4.99985 18.9988 4.99985C19.264 4.99985 19.5184 5.10521 19.7059 5.29275C19.8934 5.48028 19.9988 5.73464 19.9988 5.99985V12.9999Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9 12.0002L11 14.0002L15 10.0002"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
